import { createTheme } from "@mui/material";
import { esES } from '@mui/x-data-grid';

const theme = createTheme({
  error: {
    danger: "#d32f2f",
  },
  spaces: {
    xxs: "8px",
    xs: "16px",
    s: "24px",
    m: "32px",
    l: "40px",
    xl: "48px",
    xxl: "56px",
    xxxl: "64px",
  },
  palette: {
    primary: {
      main: "#4e5559",
      light: "#EEEEEE",
    },
    secondary: {
      main: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
    },
    text: {
      primary: "#202020",
      secondary: "#333637",
    },
  },
},
esES
);

export default theme;
